var path = 'msi/products/product/description/description.html';
var html = "<div ng-if=\"$ctrl.item.product.displayName\">\n  {{$ctrl.item.product.displayName}}\n</div>\n<og-product-price og-for=\"$ctrl.item\"></og-product-price>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;